import React, { useEffect, useState } from 'react';
import './CustomTooltip.scss';
import infoIcon from '../../assets/images/infoTooltip.svg';

const CustomTooltip = ({
    targetId,
    label,
    showTime,
    position = 'top',
    className = '',
    isVisible,
    arrowPosition = 'start',
}) => {
    const [internalVisible, setInternalVisible] = useState(false);
    const [coords, setCoords] = useState(null);
    let hideTimeout = null;

    useEffect(() => {
        const target = document.getElementById(targetId);
        if (!target) return;

        if (typeof isVisible === 'boolean') {
            const rect = target.getBoundingClientRect();
            setCoords(rect);
            return;
        }

        const handleMouseEnter = () => {
            const rect = target.getBoundingClientRect();
            setCoords(rect);
            setInternalVisible(true);
            if (showTime) {
                clearTimeout(hideTimeout);
                hideTimeout = setTimeout(() => {
                    setInternalVisible(false);
                }, showTime);
            }
        };

        const handleMouseLeave = () => {
            if (showTime) { clearTimeout(hideTimeout); }
            setInternalVisible(false);
        };

        target.addEventListener('mouseenter', handleMouseEnter);
        target.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            target.removeEventListener('mouseenter', handleMouseEnter);
            target.removeEventListener('mouseleave', handleMouseLeave);
            if (showTime) { clearTimeout(hideTimeout); }
        };
    }, [targetId, showTime, isVisible]);

    const getTooltipStyle = () => {
        if (!coords) return { display: 'none' };

        const style = {
            position: 'fixed',
            zIndex: 1000,
        };

        switch (position) {
            case 'bottom':
                return {
                    ...style,
                    top: coords.bottom + 12,
                    left: coords.left,
                    transform: 'translateX(0)',
                };
            case 'left':
                return {
                    ...style,
                    top: coords.top + coords.height / 2,
                    left: coords.left - 12,
                    transform: 'translate(-100%, -50%)',
                };
            case 'right':
                return {
                    ...style,
                    top: coords.top + coords.height / 2,
                    left: coords.right + 12,
                    transform: 'translateY(-50%)',
                };
            case 'top':
            default:
                return {
                    ...style,
                    top: coords.top - 12,
                    left: coords.left,
                    transform: 'translateX(0) translateY(-100%)',
                };
        }
    };

    const shouldShow = typeof isVisible === 'boolean' ? isVisible : internalVisible;

    return shouldShow ? (
        <div
            className={`custom-tooltip-box ${position} ${className}`}
            style={getTooltipStyle()}
        >
            <div className={`tooltip-arrow ${position} ${arrowPosition}`} />
            <div className="tooltip-content">
                <img
                    src={infoIcon}
                    alt="info"
                    className="tooltip-icon"
                />
                <span>{label}</span>
            </div>
        </div>
    ) : null;
};

export default CustomTooltip;
